import React, { useState, useContext } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { showInfoNotification } from "components/framework/notification/NotificationUtil";
import { handleFieldErrors } from "services/util/ApiUtil";
import { useIsMounted } from "services/customHooks/useIsMounted";
import ConfirmationModal from "components/framework/modals/ConfirmationModal";
import { WebhookApi } from "services/apis/WebhookApi";
import { NotificationContext } from "./NotificationList";

type Props = {
  id: string;
  notificationName: string;
  closeModal: () => void;
};

export default function NotificationResumeConfirmationModal(props: Props) {
  const intl = useIntl();
  const [showLoadingIndicator, setShowLoadingIndicator] = useState(false);
  const notificationContext = useContext(NotificationContext);
  const isMounted = useIsMounted();

  const handleResume = () => {
    if (isMounted.current) {
      setShowLoadingIndicator(true);
    }

    WebhookApi.resume(props.id)
      .then(() => {
        showInfoNotification(intl.formatMessage({ id: "notifications.resume.resumeNotification" }));
        if (isMounted.current) {
          notificationContext.notificationCallback();
          props.closeModal();
        }
      })
      .catch((error) => handleFieldErrors(error))
      .finally(() => {
        if (isMounted.current) {
          setShowLoadingIndicator(false);
        }
      });
  };

  return (
    <ConfirmationModal
      confirmCallback={handleResume}
      closeModal={props.closeModal}
      title={intl.formatMessage({ id: "notifications.resume.confirmationModalTitle" })}
      confirmButtonText={intl.formatMessage({ id: "notifications.resume.submit" })}
      showLoadingIndicator={showLoadingIndicator}>
      <p>
        <FormattedMessage
          id="notifications.resume.resumeQuestion"
          values={{ notificationName: props.notificationName }}
        />
      </p>
    </ConfirmationModal>
  );
}
